import { MAIN_QUESTS_GROUP } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const galaxyOfLemuriaQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-wishlist-added",
    ruleId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch the Main Trailer",
    caption: " Main Trailer",
    videoMimeType: "iframe/embed",
    videoUrl: "https://www.youtube.com/watch?v=l64wfib0Tpo&t=5s",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-trailer-event",
    ruleId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-trailer",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow on X",
    caption: "Stay updated with the latest news and events",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-twitter-event",
    ruleId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-twitter",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Check out the Gameplay Trailer",
    caption: "Gameplay Trailer",
    videoMimeType: "iframe/embed",
    videoUrl: "https://www.youtube.com/watch?v=qb8uywP-Xj4&t=3s",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-trailer-2-event",
    ruleId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-trailer-2",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Join Telegram channel",
    caption: "Join our Telegram community",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-telegram-event",
    ruleId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-telegram",
    linkUrl: "https://t.me/The_Galaxy_Of_Lemuria",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord Community",
    caption: "Connect with players and join the discussion",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-discord-event",
    ruleId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-discord",
    linkUrl: "https://discord.com/invite/PfSBbMByQH",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Play the game",
    caption: "Play the game and earn rewards",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-play-game-event",
    ruleId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-play-game",
    linkUrl: "https://www.playlemuria.com/",
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-onboarding-complete-event",
    ruleId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-onboarding-complete",
  },
];

const galaxyOfLemuriaQuestsRecurring: Quest[] = [
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X about playing Galaxy of Lemuria",
    caption: "Extra Gems for sharing on X",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-recurring-tweet-completed",
    ruleId: "ba82b246-e4f8-4515-b3b8-5fab8a42ec60-recurring-tweet",
    startTime: new Date("2025-03-30T02:00:00Z"),
    tweetText: "@PlayLemuria",
    recurring: true,
    tweetUsername: "@PlayLemuria",
  },
];

export const galaxyOfLemuriaQuests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      description: "",
      title: "Level 1 Supporter",
    },
    nextQuest: {
      url: "/",
      title: "Thanks for getting involved",
      label: "Discover new games you can support",
      caption: "Do quests & earn rewards",
    },
    totalGemsGranted: 50,
    quests: galaxyOfLemuriaQuestsLvl1,
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +50 <icon> Gems",
    hideOnCompletion: true,
    lockedUntilPrevious: true,
  },
  {
    key: "recurring",
    progressIcon: "ImxRewards",
    progressTemplate: "Earn extra gems daily",
    hideOnCompletion: false,
    header: {
      image: "",
      description: "",
      title: "Earn Gems by posting to socials",
    },
    totalGemsGranted: 10,
    quests: galaxyOfLemuriaQuestsRecurring,
    questGroup: MAIN_QUESTS_GROUP,
  },
];
